import { useState } from 'react';
import { CloseIcon, TaboolaLogoIcon } from 'tuui';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { STEP_IDS } from '../../config/stepIds';
import { useButtonHighlighter } from '../../hooks/useButtonHighlighter';
import { useConversionActions } from '../../hooks/useConversionActions';
import { useHandleButtonAnalyzerClick } from '../../hooks/useHandleButtonAnalyzerClick';
import styles from './buttonAnalyzer.module.scss';

export const ButtonAnalyzer = ({ currentConversion, navigateToStepId, updateDraftEvent, handleCancelWizard }) => {
    const [isHighlighting, setIsHighlighting] = useState(true);
    const { isEventNew } = useConversionActions();

    const handleButtonClick = useHandleButtonAnalyzerClick({
        setIsHighlighting,
        currentConversion,
        navigateToStepId,
        updateDraftEvent,
    });

    useButtonHighlighter({ isHighlighting, onButtonClick: handleButtonClick });

    if (!isHighlighting) {
        return null;
    }

    const handleGoBack = () => {
        if (!navigateToStepId) {
            return;
        }

        if (isEventNew(currentConversion.id)) {
            navigateToStepId(STEP_IDS.CONVERSION_TYPE_SETUP);
            return;
        }

        handleCancelWizard();
        navigateToStepId(STEP_IDS.VIEW_EVENTS_LIST);
    };

    return (
        <div className={styles['container']}>
            <TaboolaLogoIcon />
            <FormattedMessage
                id="codeless.button.analyzer.text"
                className={styles['text']}
                defaultMessage="Select one of the highlighted buttons to setup the event"
            />

            <CloseIcon onClick={handleGoBack} className={styles['close-icon']} />
        </div>
    );
};
